import { render, staticRenderFns } from "./FontPicker.vue?vue&type=template&id=5378bada&"
import script from "./FontPicker.vue?vue&type=script&lang=js&"
export * from "./FontPicker.vue?vue&type=script&lang=js&"
import style0 from "./FontPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports